const mui = {
  MuiTab: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: `${theme.palette.grey[500]}`,
        borderRight: `1px solid ${theme.palette.background.paper}`,
      }),
    },
  },
};
export default mui;
